export const ENV = {
  AIR_APP_URL: process.env.NEXT_PUBLIC_AIR_APP_URL || 'https://app.air.inc',
  API_ENDPOINT: process.env.NEXT_PUBLIC_API_ENDPOINT || '',
  API_IN_BROWSER: process.env.NEXT_PUBLIC_API_IN_BROWSER === 'true',
  BUGSNAG: process.env.NEXT_PUBLIC_BUGSNAG || '',
  IMGIX_SUB_DOMAIN: process.env.NEXT_PUBLIC_IMGIX_SUB_DOMAIN || '',
  LAUNCH_DARKLY_KEY: process.env.NEXT_PUBLIC_LAUNCH_DARKLY_KEY,
  SEGMENT_KEY: process.env.NEXT_PUBLIC_SEGMENT_KEY || '',
  VERCEL_ENV: process.env.NEXT_PUBLIC_VERCEL_ENV || '',
};
